<template>
  <div>
    <div v-if="user && accounts.length" class="item-with-submenu">
      <a v-if="userAccount" class="button submenu-trigger">{{ userAccount.title }}</a>
      <div class="submenu">
        <div :key="id" class="button" v-for="{'.key': id, title} in accounts" @click="setAccount(id)">
          {{ title }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import SubmenuMixin from '../../../mixins/submenu'

export default {
  name: 'HeaderUserAccountMenu',
  props: {
    user: { type: Object, required: true }
  },
  mixins: [SubmenuMixin('submenu', 'submenu-trigger')],

  created () {
    this.init()
  },
  computed: {
    ...mapState(['userAccount']),
    ...mapGetters('accounts2', ['accounts']),

    userId () {
      return this.user ? this.user.uid : null
    },
    accountId () {
      return this.userAccount ? this.userAccount['.key'] : null
    }
  },
  methods: {
    init () {
      this.$store.dispatch('accounts2/init', { userId: this.userId, accountId: this.accountId })
    },
    setAccount (accountId) {
      this.closeSubmenus()
      this.$store.dispatch('accounts2/setAccount', accountId)
    }
  },
  watch: {
    'user' () {
      this.init()
    },
    'userAccount' () {
      this.init()
    }
  }
}
</script>
